module.exports = {"API_ROOT":"https://api.my-air-seat.com/","ROLLBAR":{"TOKEN":"xxxxx"},"DATETIME_LOCALE":"en-GB","AUTH":{"REMEMBER_ME":false}}


//////////////////
// WEBPACK FOOTER
// ./config/config.prod.json
// module id = 2564
// module chunks = 0